import { render, staticRenderFns } from "./CallDetailsApproved.vue?vue&type=template&id=043017c0&"
import script from "./CallDetailsApproved.vue?vue&type=script&lang=js&"
export * from "./CallDetailsApproved.vue?vue&type=script&lang=js&"
import style0 from "./CallDetailsApproved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports